





































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { ALL_PROJECTS } from '@/queries/Project';

import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired } from '../UI/Form/Validations';
import {
  GQL_currentUnitProjects,
  GQL_currentUnitProjects_currentUnit_projects,
} from '@/queries/__generated__/currentUnitProjects';
import { SmartQuery } from 'vue-apollo-decorator';
import PermissionService from '@/utils/permission-service';
import DeepCopy from '@/decorators/deep-copy';

@Component
export default class ProjectForm extends Vue {
  public PermissionService = PermissionService;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public data!: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public query!: any;

  @SmartQuery<ProjectForm, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update(data) {
      return data
        .currentUnit
        .projects;
    },
  }) public projects!: GQL_currentUnitProjects_currentUnit_projects[];

  public validForm = true;

  public rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Project', 'name')}),
      },
    ],
    code: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Project', 'code') }),
      },
      {
        message: i18n => i18n.t('Error.alreadyTaken', { field: this.t_attr('Project', 'code') }),
        validation: ({ dataValue }) => {
          return !this
            .projects
            .filter(project => project.id !== this.data.id)
            .map(project => project.code)
            .includes(dataValue);
        },
      },
    ],
  };

  @Emit()
  public mutationDone() {}
}
